<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-19 17:39:31
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-17 16:27:10
 * @FilePath: /chaoyongtuan/src/components/commanderSelect/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="commander-select">
		<el-select
			v-bind="$attrs"
			class="select-content width100"
			v-model="userId"
			:clearable="showClose"
			placeholder="请选择/下拉选择团长"
			@change="change"
		>
			<el-option v-for="item in commanderList" :key="item.authority_id" :label="item.institution_name | textFormat(9)" :value="item.authority_id">
				<div class="el-option-content">
					<platform-icon style="flex-shrink: 0" class="mr-4" :platformId="item.platform_id"></platform-icon>
					<div class="fz-14 institution-name">{{ item.institution_name | textFormat(9) }}</div>
					<div class="tag-name ml-8" v-if="item.status">
						{{ item.status_txt }}
					</div>
				</div>
			</el-option>
		</el-select>
	</div>
</template>
<script>
import { getCommanderList } from '@/components/commanderSelect/index.js';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	props: {
		value: [String, Number],
		list: {
			type: Array,
			default: () => [],
		},
		platformId: {
			type: [String, Number],
			default: PLATFORM_DY.value,
		},
		showClose: {
			type: Boolean,
			default: true,
		},
		showAll: {
			type: Boolean,
			default: false,
		},
		sync: {
			type: Number,
			default: 0,
		},
		showDefault: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			commanderList: [],
			userId: '',
		};
	},
	components: {},
	watch: {
		value: {
			handler(val) {
				this.userId = val;
			},
			immediate: true,
		},
		platformId: {
			handler(val) {
				this.getList();
			},
			immediate: true,
		},
	},
	methods: {
		change(val) {
			const findActive = this.commanderList.find(val => +val.authority_id === +this.userId) || '';
			this.$emit('input', val);
			this.$emit('change', findActive);
		},
		/**
		 * 默认选中 默认的团长
		 */
		setDefaultCommander() {
			const filterList = this.commanderList.find(val => +val.is_default);
			this.userId = filterList?.authority_id || '';
			this.change(this.userId);
		},
		/**
		 * 如果type 传入 1 则是dialog的形式 然后数据传入进去 因为在点击的按钮的时候就要判断是否有授权成功的团长数据
		 * 如果type 传入 0 则请求数据
		 */
		async getList() {
			let { showAll, platformId, sync } = this;
			let type = showAll ? 1 : 0;
			if (this.list.length) {
				this.commanderList = this.list;
			} else {
				this.commanderList = await getCommanderList(type, platformId, sync);
			}
			// 如果 传入isDefalut是 true 的话 默认选中团长列表里面的默认团长
			this.showDefault && this.commanderList.length && this.setDefaultCommander();
		},
		reset() {
			this.userId = '';
		},
	},
};
</script>
<style lang="less" scoped>
.el-option-content {
	display: flex;
	align-items: center;
	.tag-name {
		line-height: 20px;
		padding: 0 3px 0 3px;
		height: 20px;
		border-radius: 3px;
		border: 1px solid @color-gy4;
		font-size: 12px;
		font-family: PingFangSC-Regular;
	}
}
.el-select-dropdown__item {
	border-bottom: 1px solid @color-gy4;
}
</style>
